import React from 'react'
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap-grid.min.css'

import Home from 'pages/home'
import ApiPage from 'pages/api-key-page'
import Workouts from 'pages/workouts'
import WorkoutComplete from 'pages/workout-complete'
import WorkoutOverview from 'pages/workout-overview'
import RoundsExerciseCountdown from 'pages/round-exercise-countdown'
import RoundCurrentOverview from 'pages/round-overview'
import RoundComplete from 'pages/round-complete'
import RoundActive from 'pages/round-active'
import FreestyleQuickstartActive from 'pages/freestyle-quickstart-active'
import CreateGroupWorkoutPage from 'pages/group-workout/pages/create'
import EditGroupWorkoutPage from 'pages/group-workout/pages/edit'
import PleaseRotate from 'components/please-rotate/please-rotate'
import Snackbar from 'components/snackbar'
import { pathsObj } from 'lib/constants/paths'
import ErrorBoundary from 'components/error'
import 'styles/globals.scss'
import 'styles/main.scss'

import EditGroupWorkoutOverview from 'pages/group-workout/overview'
import GroupWorkoutHome from 'pages/group-workout/pages/home'
import GroupWorkouts from 'pages/group-workout/pages/workouts'
import GroupWorkoutSetupNewWorkout from 'pages/group-workout/pages/setup-new-workout'
import GroupWorkoutSetupPreview from 'pages/group-workout/pages/setup-preview'
import GroupPreWorkout from 'pages/group-workout/pages/pre-workout'
import GroupWorkout from 'pages/group-workout/pages/workout'
import Updates from 'pages/updates'

const App = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path={pathsObj.main.home} element={<Home />} />
        <Route path={pathsObj.main.api} element={<ApiPage />} />
        <Route path={pathsObj.main.updates} element={<Updates />} />
        <Route path={pathsObj.workouts.workouts} element={<Workouts />} />
        <Route path={pathsObj.workouts.workoutComplete} element={<WorkoutComplete />} />
        <Route path={pathsObj.workouts.workoutOverview.default} element={<WorkoutOverview />} />
        <Route path={pathsObj.rounds.exerciseCountdown} element={<RoundsExerciseCountdown />} />
        <Route path={pathsObj.rounds.roundOverview} element={<RoundCurrentOverview />} />
        <Route path={pathsObj.rounds.roundComplete} element={<RoundComplete />} />
        <Route path={pathsObj.rounds.roundActive} element={<RoundActive />} />
        <Route path={pathsObj.freestyle.freestyleActive} element={<FreestyleQuickstartActive />} />
        <Route path={pathsObj.groupWorkout.createGroupWorkout} element={<CreateGroupWorkoutPage />} />
        <Route path={pathsObj.groupWorkout.editGroupWorkoutOverview} element={<EditGroupWorkoutOverview />} />
        <Route path={pathsObj.groupWorkout.editGroupWorkout} element={<EditGroupWorkoutPage />} />
        <Route path={pathsObj.groupWorkout.home} element={<GroupWorkoutHome />} />
        <Route path={pathsObj.groupWorkout.workouts} element={<GroupWorkouts />} />
        <Route path={pathsObj.groupWorkout.setupNewWorkout} element={<GroupWorkoutSetupNewWorkout />} />
        <Route path={pathsObj.groupWorkout.setupPreview} element={<GroupWorkoutSetupPreview />} />
        <Route path={pathsObj.groupWorkout.preWorkout} element={<GroupPreWorkout />} />
        <Route path={pathsObj.groupWorkout.workout} element={<GroupWorkout />} />
      </>
      ),
    {
    future: {
      v7_relativeSplatPath: true,
      },
    }
  )
  return (
    <ErrorBoundary>
      <PleaseRotate />
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <Snackbar />
    </ErrorBoundary>
  )
}

export default App
